import { Box, Button, Dialog, DialogActions, DialogContent, type DialogProps, DialogTitle } from '@mui/material'
import type { FC, ReactNode } from 'react'

// DialogProps は HTML の RDFa / グローバル属性として content?: string と title?: string を含む。
// そのまま交差させると content が `string & ReactNode` になり ReactElement を渡せない
// (@types/react 18.3 で ReactNode から {} が外れて顕在化した)。
// onClose も DialogProps 側は (event, reason) => void なので型を上書きしている。
type Props = Omit<DialogProps, 'content' | 'title' | 'onClose'> & {
  title: ReactNode
  content: ReactNode
  actionText: string
  onAction: () => void
  onClose: () => void
}

export const BaseDialog: FC<Props> = ({ title, content, actionText, onAction, onClose, ...dialogProps }) => {
  return (
    <Dialog maxWidth={dialogProps.maxWidth ?? 'md'} {...dialogProps} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            p: 1,
            justifyContent: 'space-between',
          }}
        >
          <Button variant="outlined" onClick={() => onClose()}>
            キャンセル
          </Button>
          <Button variant="contained" onClick={() => onAction()}>
            {actionText}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}
